import service from "./service";
import * as URL from "./url";
import AesUtil from "../encryption/AESUtil";
import swal from "sweetalert";

var aesUtil = new AesUtil(256, 1000);

class DataServices {
  getLangList(params) {
    console.log("check online", navigator.onLine)
    let url = `${URL.getCommunityWiseLanguages}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }
  getCommunityList(params) {
    let url = `${URL.getCommunityList}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }
  
  getCommunityBrandingByCommunityId(params) {
    let url = `${URL.getCommunityBrandingByCommunityId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .newpostRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getCommunitywiseLabels(params) {
    let url = `${URL.communitywiseLabels}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getsetupDetails(params) {
    let url = `${URL.setupDetails}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getRegistrationQuestions(params) {
    let url = `${URL.getRegistrationQuestions}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getComponentList(params) {
    let url = `${URL.getRoleDetails}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getApplicantList(params) {
    let url = `${URL.getApplicantByCommunityId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getApplicantList err>>", err);
        return Promise.reject(err);
      });
  }

  addChatHistoryUsingUserId(params) {
    let url = `${URL.addChatHistoryUsingUserId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getApplicantList err>>", err);
        return Promise.reject(err);
      });
  }

  addChatHistoryOnGroupUsingUserId(params) {
    let url = `${URL.addChatHistoryOnGroupUsingUserId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getApplicantList err>>", err);
        return Promise.reject(err);
      });
  }

  updateChatHistoryOnGroupUsingUserId(params) {
    let url = `${URL.updateChatHistoryOnGroupUsingUserId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getApplicantList err>>", err);
        return Promise.reject(err);
      });
  }

  getForumGroupMsgCountForUserByCommunityId(params) {
    let url = `${URL.getForumGroupMsgCountForUserByCommunityId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getApplicantList err>>", err);
        return Promise.reject(err);
      });
  }

  getForumChatGroupByCommunityId(params) {
    let url = `${URL.getForumChatGroupByCommunityId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .newpostRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getApplicantList err>>", err);
        return Promise.reject(err);
      });
  }

  checkIfForumchatIsApproved(params) {
    let url = `${URL.checkIfForumchatIsApproved}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getApplicantList err>>", err);
        return Promise.reject(err);
      });
  }
  
  getListApplicantForChatApproval(params) {
    let url = `${URL.getListApplicantForChatApproval}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getApplicantList err>>", err);
        return Promise.reject(err);
      });
  }

  approveApplicantForForumChat(params) {
    let url = `${URL.approveApplicantForForumChat}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getApplicantList err>>", err);
        return Promise.reject(err);
      });
  }

  getallnearme(params) {
    let url = `${URL.getallnearme}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  saveupdatenearmerating(params) {
    let url = `${URL.saveupdatenearmerating}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getNearMeTypes(params) {
    let url = `${URL.getNearMeTypes}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }


  getStateListForNearmeByCommunityId(params) {
    let url = `${URL.getStateListForNearmeByCommunityId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  addApplicant(params) {
    let url = `${URL.addApplicant}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .newpostRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.resolve(err);
      });
  }

  checkIfApplicantExists(params) {
    let url = `${URL.checkIfApplicantExists}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .newpostRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        return Promise.resolve(err);
      });
  }

  updateApplicant(params) {
    let url = `${URL.updateUserProfile}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("updateApplicant err>>", err);
        return Promise.reject(err);
      });
  }
  updateFcmId(params) {
    console.log("params", params);
    let url = `${URL.updatefcmIdForUserUsingPOST}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("updateApplicant err>>", err);
        return Promise.reject(err);
      });
  }

  getVoicBotStatus(params) {
    let url = `${URL.getVoicBotStatus}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getVoicBotStatus err>>", err);
        return Promise.reject(err);
      });
  }

  getPhrasesForVoiceBot(params) {
    let url = `${URL.getPhrasesForVoiceBot}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getPhrasesForVoiceBot err>>", err);
        return Promise.reject(err);
      });
  }

  getEmergencyContacts(params) {
    let url = `${URL.getEmergencyContacts}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getEmergencyContacts err>>", err);
        return Promise.reject(err);
      });
  }

  saveEmergencyContacts(params) {
    let url = `${URL.saveEmergencyContacts}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("saveEmergencyContacts err>>", err);
        return Promise.reject(err);
      });
  }

  getTriggerWordsForVoiceBot(params) {
    let url = `${URL.getTriggerWordsForVoiceBot}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getTriggerWordsForVoiceBot err>>", err);
        return Promise.reject(err);
      });
  }

  getUserProfile(params) {
    let url = `${URL.getUserProfile}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getUserProfile err>>", err);
        return Promise.reject(err);
      });
  }

  searchnearme(params) {
    let url = `${URL.searchnearme}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service.newpostRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        return Promise.resolve(err);
      });
  }

  getStaticContent(params) {
    let url = `${URL.getStaticContent}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getComponentWiseRoleDetails(params) {
    let url = `${URL.getComponentWiseRoleDetails}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  ChangeCaseStatusForService(params) {
    let url = `${URL.ChangeCaseStatusForService}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .putRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getCaseDetailsForService(params) {
    let url = `${URL.getCaseDetailsForService}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getRoleWiseContent(params) {
    let url = `${URL.getRoleWiseContent}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  likeContent(params) {
    let url = `${URL.likeContent}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("likeContent err>>", err);
        return Promise.reject(err);
      });
  }

  unlikeContent(params) {
    let url = `${URL.unlikeContent}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("unlikeContent err>>", err);
        return Promise.reject(err);
      });
  }

  addCommentToContent(params) {
    let url = `${URL.addCommentToContent}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("unlikeContent err>>", err);
        return Promise.reject(err);
      });
  }

  getContentWiseComments(params) {
    let url = `${URL.getContentWiseComments}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getContentWiseComments err>>", err);
        return Promise.reject(err);
      });
  }

  getServiceByCommunityId(params) {
    let url = `${URL.getServiceByCommunityId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getQuestionsByServiceId(params) {
    let url = `${URL.getQuestionsByServiceId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }
  
  getGoogleNearme(params) {
    let url = "&key=" + params.apiKey + "&location=" + params.lat + "," + params.lng + "&radius=" + params.radius + "&type=" + params.keywords;
    return service.getGoogleNearme(url, params).then(res => {
      return Promise.resolve(res);
    }).catch(err => {
      console.log('searchnearme err>>', err)
      return Promise.reject(err);
    })
  }

  addCaseForService(params) {
    let url = `${URL.addCaseForService}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("addCaseForService err>>", err);
        return Promise.reject(err);
      });
  }

  getCaseListForService(params) {
    let url = `${URL.getCaseListForService}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getCaseListForService err>>", err);
        return Promise.reject(err);
      });
  }

  getSurveyByCommunityId(params) {
    let url = `${URL.getSurveyByCommunityId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getSectionBySurveyId(params) {
    let url = `${URL.getSectionBySurveyId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getSurveySectionQuestionsBySectionId(params) {
    let url = `${URL.getSurveySectionQuestionsBySectionId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getQuestionsBySurveyId(params) {
    let url = `${URL.getQuestionsBySurveyId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  addCaseSetForSurveyUsingPOST(params) {
    let url = `${URL.addCaseSetForSurveyUsingPOST}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }


  getCaseSetForSurveyByUserId(params) {
    let url = `${URL.getCaseSetForSurveyByUserId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("err>>", err);
        return Promise.reject(err);
      });
  }

  getCaseSetSurveyDetails(params) {
    let url = `${URL.getCaseSetSurveyDetails}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }
  dashboardLogin(params) {
    let url = `${URL.dashboardLogin}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        swal({
          title: "Credentials are incorrect",
          icon: "warning",
          button: "Ok",
        })
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }
  IdentifyUserType(params) {
    let url = `${URL.IdentifyUserType}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        swal({
          title: "invalid user",
          icon: "warning",
          button: "Ok",
        })
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }
  ResetPin(params) {
    let url = `${URL.ResetPin}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        swal({
          title: "invalid user",
          icon: "warning",
          button: "Ok",
        })
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }
  ResetPassword(params) {
    let url = `${URL.ResetPassword}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }
  getAppVersion(params) {
    let url = `${URL.getAppVersion}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getAvatarByCommunityId(params) {
    let url = `${URL.getAvatarByCommunityId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getAvatarByCommunityId err>>", err);
        return Promise.reject(err);
      });
  }
  getCaseDetailsForService(params) {
    let url = `${URL.getCaseDetailsForService}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getCaseDetailsForService err>>", err);
        return Promise.reject(err);
      });
  }
  inactiveUser(params) {
    let url = `${URL.inactiveUser}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service.newpostRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("inactiveUser err>>", err);
        return Promise.resolve(err);
      });
  }
  getTemplatesByCommunityId(params) {
    let url = `${URL.getTemplatesByCommunityId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service.newpostRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getTemplatesByCommunityId err>>", err);
        return Promise.resolve(err);
      });
  }

  contentListByCommunityId(params) {
    let url = `${URL.contentListByCommunityId}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service.newpostRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("contentListByCommunityId err>>", err);
        return Promise.resolve(err);
      });
  }

  getWhatsappReminder(params) {
    let url = `${URL.remainderNotificationUsingWhatsapp}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .postRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  getCalenderRemaindersForUser(params) {
    let url = `${URL.getCalenderRemaindersForUser}`;
    let encryptParamWIthHeader = this.handleEncryptParams(params);
    return service
      .newpostRequest(
        url,
        encryptParamWIthHeader.encryptParam,
        encryptParamWIthHeader.headers
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("masterLanguageList err>>", err);
        return Promise.reject(err);
      });
  }

  sendPushNotification(params) {
    var payload = {
        "to": params.to,
        "priority": "high",
        "notification": {
            "title": params.title,
            "body": params.message,
            "sound":"default",
            "notiKey": 'notiKey',
            "click_action": "FCM_PLUGIN_ACTIVITY",
            "page": params.page
        },  
        "data": {
          "title": params.title,
          "body": params.message,
          "page": params.page,
          "applicant": params.applicant,
          "chatType": params.chatType,
          "senderObj": params.senderObj 
        }
    };
    let url = `${URL.sendPushNotification}`;
    let headers = {};
    return service
      .notiRequest(
        url,
        payload,
        headers = {
            "Authorization": 'key=' + 'AAAAeoBzXiw:APA91bGRxaHor7rR2l7UaHthF11xCH1rfzrHZ2g_5nLl585quV9ARdnsd6BJx9RFZMgusP_Ai-0Tjul48IEzCVBEoEEhPS7gxZd_XPAECsJpbw_tOmPVgS63cabqPdxMqr2APsSURgf7',
            // "Authorization": 'key=' + 'AAAAUFk7iV4:APA91bFjT6Le2IPZjm2PeGQZBdlqRiM8ihYYL2aPJ1AqMofMFEAtkwklAHigoJkbcy9s98qTl8g_1zgLynZz3gwu_6-s_UCqPMWY_60s0W1u-t4OtmWIvxKYk2paqSOW9O7YAOeNfo-8',
            "Content-Type": 'application/json'
        }
      )
      .then((res) => {
        return Promise.resolve(res);
      })
      .catch((err) => {
        console.log("getApplicantList err>>", err);
        return Promise.reject(err);
      });
  }

  getRasaResponse(params) {
    console.log("inside getBotResponse");
		return service.getBotResponse({
        url: params.url,
        text: params.text
      }
		)
			.then(response => {
				//this.hideLoader();
				console.log('getRequest res>>', response.status)
				return Promise.resolve(response);
			})
			.catch(error => {
				//this.hideLoader();
				console.log('getRequest err>>', error)
				return Promise.reject(error.message);
			})
	}
  

  handleEncryptParams(params) {
    let paramString = JSON.stringify(params);
    let salt = aesUtil.generateSalt();
    let iv = aesUtil.generateiv();
    let encryptParam = { _r: aesUtil.encrypt(salt, iv, paramString) };
    return { encryptParam, headers: { _1: salt, _2: iv } };
  }
}

export default new DataServices();
